<template>
  <div class="contain2">
    <div class="contain-box3">
      <div class="filter-container">
        <div class="filter-container-left">
          <div class="filter-title">我的成绩</div>
        </div>
        <div class="filter-container2-right">
          <div class="filter-item">
            <img src="../../../assets/image/date.png" alt="" />
            <!-- 学年: -->
            <el-date-picker
              v-model="listQuery.school_year"
              type="year"
              value-format="yyyy"
              style="margin-right: 20px"
              placeholder="选择学年"
            >
            </el-date-picker>
            <el-select
              v-model="listQuery.semester"
              placeholder="请选择学期"
              clearable
            >
              <el-option label="第一学期" :value="1"> </el-option>
              <el-option label="第二学期" :value="2"> </el-option>
            </el-select>
          </div>
          <el-button class="filter-item" type="primary" @click="handleCreate"
            >查询</el-button
          >
          <img src="../../../assets/image/achievement.png" alt="" />
        </div>
      </div>

      <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        stripe
        border
        fit
        :header-cell-style="{ background: '#F9FAFD', border: 'none' }"
        highlight-current-row
      >
        <el-table-column align="center" label="学期" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.class_course.semester == 1 ? "第一学期" : "第二学期" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="课程名称" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.class_course.school_course.name }}
          </template>
        </el-table-column>
        <el-table-column label="平时成绩" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.usual_score }}
          </template>
        </el-table-column>
        <el-table-column label="期末成绩" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.final_score }}
          </template>
        </el-table-column>
        <el-table-column label="总成绩" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_score }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      btnLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },

      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加",
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: "",
        username: "",
        password: "",
        roles: [],
        permissions: [],
      },
      rules: {
        create: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" },
          ],
          password: [
            { required: true, message: "密码不能为空", trigger: "change" },
          ],
        },
        update: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" },
          ],
        },
      },
      //角色复选框
      checkAllRoles: false,
      isIndeterminateRoles: false,
      allRoles: [],
      //权限复选框
      checkAllPermissions: false,
      isIndeterminatePermissions: false,
      allPermissions: [],
      //按钮提交loading
      btnLoading: false,
    };
  },
  created() {
    this.getList();
    this.getRoleAll();
    this.getPermissionAll();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/userend/user/score",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data;
        this.total = response.data.length;
        this.listLoading = false;
      });
    },
    getRoleAll() {
      request({
        url: "/api/backend/role/all",
        method: "get",
        params: {},
      }).then((response) => {
        this.allRoles = response.data;
      });
    },
    getPermissionAll() {
      request({
        url: "/api/backend/permission/all",
        method: "get",
        params: {},
      }).then((response) => {
        this.allPermissions = response.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      (this.form = {
        id: "",
        username: "",
        password: "",
        roles: [],
        permissions: [],
      }),
        (this.btnLoading = false);
      this.checkAllRoles = false;
      this.isIndeterminateRoles = false;
      this.checkAllPermissions = false;
      this.isIndeterminatePermissions = false;
    },

    handleCreate() {
      this.getList();
      // this.resetForm()
      // this.dialogStatus = 'create'
      // this.dialogFormVisible = true
      // this.$nextTick(() => {
      //   this.$refs['form'].clearValidate()
      // })
    },
    handleUpdate(row) {
      this.resetForm();
      let form = Object.assign({}, row); // copy obj
      let roles = [];
      let permissions = [];
      for (let i = 0; i < form.roles.length; i++) {
        roles.push(form.roles[i].id);
      }
      for (let i = 0; i < form.permissions.length; i++) {
        permissions.push(form.permissions[i].id);
      }
      this.handleCheckedRolesChange(form.roles);
      this.handleCheckedPermissionsChange(form.permissions);
      form.permissions = permissions;
      form.roles = roles;
      this.form = form;
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/admin/save",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/admin/delete",
            method: "post",
            params: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleCheckAllRolesChange(val) {
      let checkedRoles = [];
      if (val) {
        for (let i = 0; i < this.allRoles.length; i++) {
          checkedRoles.push(this.allRoles[i].id);
        }
      }
      this.form.roles = checkedRoles;
      this.isIndeterminateRoles = false;
    },
    handleCheckedRolesChange(value) {
      let checkedCount = value.length;
      this.checkAllRoles = checkedCount === this.allRoles.length;
      this.isIndeterminateRoles =
        checkedCount > 0 && checkedCount < this.allRoles.length;
    },
    handleCheckAllPermissionsChange(val) {
      let checkedPermissions = [];
      if (val) {
        for (let i = 0; i < this.allPermissions.length; i++) {
          checkedPermissions.push(this.allPermissions[i].id);
        }
      }
      this.form.permissions = checkedPermissions;
      this.isIndeterminatePermissions = false;
    },
    handleCheckedPermissionsChange(value) {
      let checkedCount = value.length;
      this.checkAllPermissions = checkedCount === this.allPermissions.length;
      this.isIndeterminatePermissions =
        checkedCount > 0 && checkedCount < this.allPermissions.length;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" >
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.pagination-container {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contain-box3 {
  background: #ffffff;
  border-radius: 8px;
  padding: 11px 0 30px 0;
  .filter-container {
    height: 90px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .filter-container-left {
      .filter-title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1e2134;
        margin-right: 70px;
        margin-bottom: 10px;
      }
    }
    .filter-container2-right {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .filter-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
        .to {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #cccccc;
          margin: 0 10px;
        }
        &:nth-child(2) {
          margin-left: 20px;
        }
        &:nth-child(3) {
          margin-left: 20px;
        }
      }
      img {
        width: 164px;
        height: 90px;
        margin-left: 40px;
      }
    }
  }
}
</style>
